var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 56,
    viewBox: "0 0 218 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.08738H10.2504C16.8671 1.08738 21.3361 1.38587 23.6573 1.98287C23.6573 21.1524 27.7792 3.56063 28.994 4.92519C30.2089 6.28974 28.43 8.26195 28.7337 9.94632C29.0374 11.6094 31.7275 14.4451 31.7275 19.3489V37.4826C31.7275 42.1306 31.4997 45.2435 31.0441 46.8212C30.6102 48.3777 29.8401 49.6037 28.7337 50.4991C27.6273 51.3733 26.2606 51.9916 24.6335 52.3541C23.0065 52.6952 20.5551 52.8658 17.2793 52.8658H0V1.08738ZM13.6998 9.94632V44.0069C15.6739 44.0069 20.9005 23.4071 21.3561 22.6395C21.8116 21.8506 18.0277 39.9452 18.0277 36.4911L22.8605 16.3783C22.8605 14.033 19.1281 11.9996 18.9064 11.8047C18.4351 11.3903 17.301 10.7245 16.7586 10.426C16.2163 10.1062 15.1967 9.94632 13.6998 9.94632Z",
    fill: "url(#paint0_linear_659_3959)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9373 1.69503L67.0032 52.8658L61.9373 52.1942L59.6785 21.3318L45.2948 51.9063L32.3796 52.8658L35.4059 37.7065L61.9373 1.69503ZM43.9442 37.4826C44.6169 31.0543 55.9092 30.6221 55.1914 22.2796C56.0187 31.8945 43.9442 32.9732 43.9442 37.4826Z",
    fill: "url(#paint1_linear_659_3959)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6018 1.08738V52.8658H86.5942L71.559 11.8047L79.4677 52.8658H68.0133V1.08738H79.4677L94.8716 44.0069L93.1376 11.8047L98.6018 1.08738Z",
    fill: "url(#paint2_linear_659_3959)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.396 1.08738V11.4495H117.208L122.26 52.8658H108.561V19.3489L100.458 11.4495V1.08738H130.396Z",
    fill: "url(#paint3_linear_659_3959)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M163.686 1.08738V52.8658H149.987L157.696 29.3272L142.079 36.4295L138.472 52.8658H132.187V1.08738H145.887L142.079 21.3318L140.55 28.9992L153.54 23.8608L155.618 1.08738H163.686Z",
    fill: "url(#paint4_linear_659_3959)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M181.585 1.08738L177.552 27.0933L181.585 52.8658H167.886L170.974 27.0933L167.886 1.08738H181.585Z",
    fill: "url(#paint5_linear_659_3959)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M214.583 25.4894L202.055 16.7584V12.9206C202.055 11.1296 201.892 9.98896 201.567 9.49857C201.241 9.00819 200.699 8.76299 199.94 8.76299C199.115 8.76299 198.486 9.09347 198.052 9.75443C197.64 10.4154 197.434 11.4175 197.434 12.7607C197.434 14.4877 197.673 15.7883 198.15 16.6625C198.606 17.5366 200.775 22.6242 202.901 23.8608C208.997 27.4215 211.958 26.3103 213.542 28.5917C215.126 30.873 215.917 34.5509 215.917 39.6254C215.917 43.3139 215.473 46.0324 214.583 47.7807C213.715 49.529 212.023 51.0002 209.507 52.1942C206.99 53.3668 204.062 53.9532 200.721 53.9532C197.054 53.9532 193.92 53.2709 191.316 51.9063C188.735 50.5418 187.043 48.8041 186.24 46.6933C185.437 44.5825 185.036 41.5869 185.036 37.7065V25.4894L197.759 34.3164V40.6168C197.759 42.557 197.933 43.8043 198.28 44.3587C198.649 44.913 199.289 45.1902 200.2 45.1902C201.111 45.1902 201.784 44.8384 202.218 44.1348C202.673 43.4312 202.901 42.3864 202.901 41.0006C202.901 37.9516 202.478 35.9581 201.632 35.02C200.764 34.0819 199.219 31.1953 195.813 28.9992C192.407 26.7818 189.559 26.4915 188.453 25.4894C187.346 24.4873 186.424 23.1015 185.687 21.3318C184.971 19.5622 184.613 17.3021 184.613 14.5517C184.613 10.586 185.123 7.68627 186.142 5.85266C187.184 4.01904 188.854 2.59052 191.154 1.5671C193.453 0.522368 196.23 0 199.484 0C203.042 0 206.068 0.56501 208.563 1.69503C211.08 2.82505 212.739 4.25357 213.542 5.98058C214.366 7.68627 214.778 10.5966 214.778 14.7116L214.583 25.4894Z",
    fill: "url(#paint6_linear_659_3959)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_659_3959",
    x1: 0,
    y1: 26.9766,
    x2: 215.917,
    y2: 26.9766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B30505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9819C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_659_3959",
    x1: 0,
    y1: 26.9766,
    x2: 215.917,
    y2: 26.9766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B30505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9819C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_659_3959",
    x1: 0,
    y1: 26.9766,
    x2: 215.917,
    y2: 26.9766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B30505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9819C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_659_3959",
    x1: 0,
    y1: 26.9766,
    x2: 215.917,
    y2: 26.9766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B30505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9819C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_659_3959",
    x1: 0,
    y1: 26.9766,
    x2: 215.917,
    y2: 26.9766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B30505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9819C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_659_3959",
    x1: 0,
    y1: 26.9766,
    x2: 215.917,
    y2: 26.9766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B30505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9819C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_659_3959",
    x1: 0,
    y1: 26.9766,
    x2: 215.917,
    y2: 26.9766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B30505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9819C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0ee97b1cea1349e8cb7e03785074f2e7.svg";
export { ForwardRef as ReactComponent };